import { HomeFooter } from "homepage/homeFooter";
import { Header } from "homepage/homeHeader";
import React from "react";

const ConfirmationPasswordMessage = () => {
  return (
    <>
      <Header />
      <div className="d-flex justify-content-center align-items-center "  style={{ minHeight: "46vh" }}>
        <div className="text-center mb-4">
          <div className="card shadow-lg p-4" style={{ maxWidth: "600px" }}>
            <h3 className="text-center mb-1">
              <span className="position-relative fw-bold z-1">
                Reset Password
                <img
                  src="../../assets/img/front-pages/icons/section-title-icon.png"
                  alt="laptop charging"
                  className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                />
              </span>
              <br />
            </h3>
            <p>
              {" "}
              We have sent a password reset email to your email address 
              Please check your inbox to continue
            </p>
          </div>
        </div>
      </div>
      <HomeFooter />
    </>
  );
};

export default ConfirmationPasswordMessage;
